// JS for Plan Addons
import $ from 'jquery'
import { handleCartToggle, refreshFragments } from '../components/cart-ajax'

      $(document).on('change', '.addon-product-checkbox', function() {
        handleCartToggle($(this), {
          getLabelEl: function ($cb) {
            return $('label[for="' + $cb.attr('id') + '"]');
          },
          getAddingText: function () {
            return 'adding';
          },
          getAddedText: function () {
            return 'added to cart';
          },
          getRemovingText: function () {
            return 'removing';
          },
          getRemovedText: function (info) {
            return 'add ' + info.product_title;
          },
          removeData: {
            product_sku: '',
            quantity: 1,
            variation_id: '',
          },
        });
      });

      $(document).on('click', '.btn-plan-addons-continue', function (e) {
        if (typeof EAPLUS_VARS === 'undefined') {
            return false;
        }
        var addons = $('input.addon-product-checkbox:checkbox:checked').map(function() {
            var product_info = $(this).data('product-info');
            return product_info.product_title;
        }).get();
        var dataLayer = (window.dataLayer = window.dataLayer || []);
        dataLayer.push({
            'event': 'plan_addon',
            'client': EAPLUS_VARS.client_code,
            'tracking_code': EAPLUS_VARS.tracking_code,
            'discount': EAPLUS_VARS.discount,
            'conversion': '',
            'addon': addons
        });
      });

      $(document.body).on('added_to_cart removed_from_cart', function(event, fragments) {
        refreshFragments(fragments, 'wc_fragments_loaded');
      });
